module.exports = __webpack_public_path__ + "img/book2.5432006e.jpg";